import { EnvironmentVariables } from '@environments/model';

export const VARIABLES: EnvironmentVariables = {
  buildTimestamp: 1793718383064,
  commitHash: '08dc5a3',
  version: '2.1.0',
};
